import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ClientModule } from 'src/app/constantes/client-modules.constantes';
import { ClientModuleModel } from '../../models/clients/client.model';
import { ConfigService } from '../config/config.service';
import { BaseClientService } from './base-client.service';

@Injectable({
  providedIn: 'root',
})
export class ClientService extends BaseClientService {
  private cacheModules: Array<ClientModuleModel> = null;
  public isMultiEntite: boolean
  public isDroitTypeEntreprise: boolean;
  public isEmargementNumerique: boolean;

  constructor(client: HttpClient, configService: ConfigService)
  {
    super(client, configService);
  }

  public loadClientModules(): Observable<Array<ClientModuleModel>>
  {
    if (this.cacheModules) {
      return of(this.cacheModules);
    }

    return this.client
      .get<Array<ClientModuleModel>>(`${this.baseUrlApi}/api/c/ParametresClient/GetModulesClient`)
      .pipe(tap(modules => this.stockModules(modules)));
  }

  private stockModules(modules: Array<ClientModuleModel>) {
    this.cacheModules = modules;
    this.isMultiEntite = modules.some(m => m.code === ClientModule.MultiEntite);
    this.isEmargementNumerique = modules.some(m => m.code === ClientModule.EmargementNumerique);
  }
}
